import { queryJsomCsom } from "../sharePointList.connection.helpers";
import valueHandler from "./sharePointList.valueHandler.csom"

const csomImplementation = {
    query: queryJsomCsom,
    getValue: valueHandler,
};

export default csomImplementation;